import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
interface InterventionFileState {
  id: any;
  type: any;
  number: any;
  companyId: any;
  company: any;
  workPlaceId: any;
  workPlace: any;
  agentId: any;
  agent: any;
  requestFileId?: any;
  requestFile: any;
  statusId: any;
  status: any;
  interventionFileSystemTypes: any;
  hasJournal: any;
  attachedImage: any;
  reportedDefect: any;
  ascertainment: any;
  takenIntoService: any;
  deviceRepaired: any;
  estimatedPrice: any;
  operations: any;
  isAccumulatorChanged: any;
  isBatteryChanged: any;
  consumptionDetails: any;
  canBeUpgradedWithPresales: any;
  canBeUpgradedWithoutPresales: any;
  recommendationDetails: any;
  helionEngineers: any;
  representativeSignature: any;
  deliveryDate: any;
  timeTransport: any;
  traveledKilometers: any;
  laborTime: any;
  signature: any;
  contactPersonObservations: any;
  latitude: any;
  longitude: any;
  isActive: any;
  changes: any; // NEW
  interventionFileInvoiceFiles: any; // NEW
  device: any;
  interventionFilePerformOperations: any;
  otherActivities: any;
  isInvoiceSent: any;
  interventionFileEquipments: any;
  selectedRecords: any[]; // NEW: for bulk operations
  queryKey: {
    [key: string]: any;
  };
  props: {
    [key: string]: any;
  };
}

const currentDate = moment().format('YYYY-MM-DD');

export const initialState: InterventionFileState = {
  id: '',
  type: null,
  number: null,
  companyId: '',
  company: null,
  workPlaceId: '',
  workPlace: null,
  agentId: '',
  agent: null,
  requestFileId: '',
  requestFile: null,
  statusId: 1,
  status: null,
  interventionFileSystemTypes: [],
  hasJournal: true,
  attachedImage: '',
  reportedDefect: '',
  ascertainment: '',
  takenIntoService: false,
  deviceRepaired: false,
  estimatedPrice: 350,
  operations: '',
  isAccumulatorChanged: false,
  isBatteryChanged: false,
  consumptionDetails: '',
  canBeUpgradedWithPresales: false,
  canBeUpgradedWithoutPresales: false,
  recommendationDetails: '',
  helionEngineers: [],
  representativeSignature: '',
  deliveryDate: currentDate,
  timeTransport: 0,
  traveledKilometers: 0,
  laborTime: 0,
  signature: '',
  contactPersonObservations: '',
  latitude: 0,
  longitude: 0,
  changes: [],
  interventionFileInvoiceFiles: [],
  interventionFileEquipments: [],
  device: 'Selecteaza device',
  interventionFilePerformOperations: [],
  otherActivities: null,
  isInvoiceSent: false,
  isActive: false,
  selectedRecords: [], // NEW: initialize empty array
  queryKey: {
    isActive: true,
    isAgentIncluded: false,
    isWorkPlacesIncluded: false,
    isAccountManagerIncluded: false,
    ids: [],
  },
  props: { searchTerm: '', searchTermType: '', skip: 1, take: 10, totalItems: 0 },
};

const interventionFileSlice = createSlice({
  name: 'interventionFile',
  initialState,
  reducers: {
    setInterventionFile: (state, action: PayloadAction<Partial<InterventionFileState>>) => {
      return { ...state, ...action.payload };
    },
    updateField: (state: any, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
    // NEW: Actions for managing selected records
    setSelectedRecords: (state, action: PayloadAction<any[]>) => {
      state.selectedRecords = action.payload;
    },
    addSelectedRecord: (state, action: PayloadAction<any>) => {
      state.selectedRecords.push(action.payload);
    },
    removeSelectedRecord: (state, action: PayloadAction<string>) => {
      state.selectedRecords = state.selectedRecords.filter((record) => record.id !== action.payload);
    },
    clearSelectedRecords: (state) => {
      state.selectedRecords = [];
    },
    updatePerformOperation: (state, action: PayloadAction<string>) => {
      const operation = action.payload;
      const index = state.interventionFilePerformOperations.findIndex((op: any) => op.operation === operation);

      if (index !== -1) {
        // Toggle selection
        state.interventionFilePerformOperations[index].isSelected =
          !state.interventionFilePerformOperations[index].isSelected;
      } else {
        // Add new operation
        state.interventionFilePerformOperations.push({ operation, isSelected: true });
      }
    },
    addInterventionFileEquipments: (state, action: PayloadAction<any>) => {
      state.interventionFileEquipments.push(action.payload); // Add a new pair to the state
    },
    updateInterventionFileEquipments: (state, action: PayloadAction<{ index: number; updatedEquipment: any }>) => {
      const { index, updatedEquipment } = action.payload;
      if (index >= 0 && index < state.interventionFileEquipments.length) {
        state.interventionFileEquipments[index] = updatedEquipment;
      }
    },
    deleteInterventionFileEquipmentsByIndex: (state, action: PayloadAction<number>) => {
      // Remove a pair by index
      state.interventionFileEquipments.splice(action.payload, 1);
    },
  },
});

export const {
  setInterventionFile,
  updateField,
  updateProps,
  setSelectedRecords,
  addSelectedRecord,
  removeSelectedRecord,
  clearSelectedRecords,
  updatePerformOperation,
  addInterventionFileEquipments,
  updateInterventionFileEquipments,
  deleteInterventionFileEquipmentsByIndex,
} = interventionFileSlice.actions;

export default interventionFileSlice.reducer;
